export const CAL_API_URL = process.env.NEXT_PUBLIC_CAL_API_URL || "https://api.cal.com/v2";
export const CAL_API_VERSION_DEFAULT = "2024-06-14";
export const CAL_API_VERSION_BOOKINGS = "2024-08-13";
export const CAL_API_VERSION_BOOKING_CREATE_OVERRIDES = "2026-02-25";
export const CAL_API_VERSION_BOOKING_RESCHEDULE = "2026-02-25";
export const CAL_API_VERSION_BOOKING_RESCHEDULE_LEGACY = CAL_API_VERSION_BOOKINGS;
export const CAL_API_VERSION_SLOTS = "2024-09-04";

// Shared wait before checking Cal's destination-calendar busy-times after a booking
// mutation, so Cal/Microsoft Graph/Google have time to propagate the change.
export const CAL_DESTINATION_CALENDAR_PROPAGATION_DELAY = "2 minutes";
